export default __webpack_public_path__ + "static/media/BSLogo.de33e754.png";